import Modal from "./Modal"

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/index.jsx